import {IonIcon} from "@ionic/react";
import React from "react";

export const ActionButton = ({ icon, action }) => {
  return (
    <IonIcon icon={icon} onClick={action}/>
  )
}